import React, { FC } from 'react';
import BodyTopBlock, { ActionType } from 'src/components/BodyTopBlock';
import { getTransportsSectionTopBlockParams } from './functions';

const TransportsSectionTopBlock: FC<{ actions?: ActionType[] }> = (props) => {
    const params = getTransportsSectionTopBlockParams();

    return (
        <BodyTopBlock
            tabs={params.tabs}
            selectTab={params.selected}
            onChangeTab={params.handleChange}
            actions={props.actions}
        />
    );
};

export default TransportsSectionTopBlock;
